module.exports = {
  "indicator": {
    "position": "absolute",
    "bottom": 0,
    "left": 0,
    "right": 0,
    "height": "50",
    "itemColor": "rgba(255,255,255,0.5)",
    "itemSelectedcolor": "rgba(255, 255, 255, 1)",
    "itemSize": "14"
  },
  "slider": {
    "borderRadius": "16"
  },
  "image": {
    "borderRadius": "16"
  },
  "div_out": {
    "borderRadius": "16",
    "position": "relative"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-556248de!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-swiper/index.vue
// module id = 472
// module chunks = 0 1